/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';


class CalloutHighlightDirective {
    public restrict = 'A';
    public scope = {};

    constructor(private $timeout: any) {
        this.restrict = 'A';
        this.scope = {
            coIndex: '<',
            coCurrent: '<'
        };
    }

    public link = ($scope: any, $element: any, $attr: any) => {


        // this triggers everytime the coCurrent changes as well as when the page first loads
        $scope.$watch('coCurrent', function(): any {
            if ($scope.coIndex.constructor === Array) {
                var valPos: number = $scope.coIndex.indexOf($scope.coCurrent);
                if (valPos !== undefined && valPos >= 0 && $scope.coIndex[valPos] === $scope.coCurrent) {
                    $element.addClass('hightlightElement');
                } else if (valPos === undefined || valPos < 0 ) {
                    $element.removeClass('hightlightElement');
                }
            } else {
                if ($scope.coIndex === $scope.coCurrent) {
                    $element.addClass('hightlightElement');
                } else {
                    $element.removeClass('hightlightElement');
                } 
            }
        });    

    }

    public static DirectiveFn($timeout: any): CalloutHighlightDirective {
        return new CalloutHighlightDirective($timeout);
    }
}

CalloutHighlightDirective.DirectiveFn.$inject = ['$timeout'];

angular.module('beneple.global').directive('calloutHighlight', CalloutHighlightDirective.DirectiveFn);




// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/callout_highlight.directive.ts